import {EventCalendarApiServiceClient} from "../../proto/generated/api_entities_grpc_web_pb";
import {getProxyUrl} from "../helpers/getProxyUrl";
import {
  EventCalendarApiEventCalendarListRequest,
  EventCalendarApiEventCalendarListResponse,
  EventCalendarApiEventCalendarCreateRequest,
  EventCalendarApiEventCalendarCreateResponse,
  EventCalendarApiEventCalendarUpdateRequest,
  EventCalendarApiEventCalendarUpdateResponse,
  EventCalendarApiEventCalendarDeleteRequest,
  EventCalendarApiEventCalendarDeleteResponse,
  EventCalendarApiEventCalendarHideRequest,
  EventCalendarApiEventCalendarHideResponse,
  EventCalendarApiEventCalendarShowRequest,
  EventCalendarApiEventCalendarShowResponse,
} from "../../proto/generated/api_entities_pb";
import {API} from "../API";

const client = new EventCalendarApiServiceClient(getProxyUrl(), null, null);

export class EventCalendarApi {
  static async getEventCalendarList(req: EventCalendarApiEventCalendarListRequest): Promise<EventCalendarApiEventCalendarListResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarListRequest, EventCalendarApiEventCalendarListResponse>(client, client.eventCalendarList, req, resolve, reject)
    })
  }

  static async createEventCalendar(req: EventCalendarApiEventCalendarCreateRequest): Promise<EventCalendarApiEventCalendarCreateResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarCreateRequest, EventCalendarApiEventCalendarCreateResponse>(client, client.eventCalendarCreate, req, resolve, reject)
    })
  }

  static async updateEventCalendar(req: EventCalendarApiEventCalendarUpdateRequest): Promise<EventCalendarApiEventCalendarUpdateResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarUpdateRequest, EventCalendarApiEventCalendarUpdateResponse>(client, client.eventCalendarUpdate, req, resolve, reject)
    })
  }

  static async deleteEventCalendar(req: EventCalendarApiEventCalendarDeleteRequest): Promise<EventCalendarApiEventCalendarDeleteResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarDeleteRequest, EventCalendarApiEventCalendarDeleteResponse>(client, client.eventCalendarDelete, req, resolve, reject)
    })
  }

  static async hideEventCalendar(req: EventCalendarApiEventCalendarHideRequest): Promise<EventCalendarApiEventCalendarHideResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarHideRequest, EventCalendarApiEventCalendarHideResponse>(client, client.eventCalendarHide, req, resolve, reject)
    })
  }

  static async showEventCalendar(req: EventCalendarApiEventCalendarShowRequest): Promise<EventCalendarApiEventCalendarShowResponse> {
    return new Promise((resolve, reject) => {
      API.call<EventCalendarApiEventCalendarShowRequest, EventCalendarApiEventCalendarShowResponse>(client, client.eventCalendarShow, req, resolve, reject)
    })
  }
}

